/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiErrorResponseFromJSON, StreemApiErrorResponseToJSON, } from './';
export function StreemApiBatchCreateUserResponseFailureFromJSON(json) {
    return StreemApiBatchCreateUserResponseFailureFromJSONTyped(json, false);
}
export function StreemApiBatchCreateUserResponseFailureFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'error': !exists(json, 'error') ? undefined : StreemApiErrorResponseFromJSON(json['error']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'companyCode': !exists(json, 'company_code') ? undefined : json['company_code'],
    };
}
export function StreemApiBatchCreateUserResponseFailureToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'error': StreemApiErrorResponseToJSON(value.error),
        'name': value.name,
        'email': value.email,
        'company_code': value.companyCode,
    };
}
//# sourceMappingURL=StreemApiBatchCreateUserResponseFailure.js.map